<template>
  <v-container>
    <AppDashboard :modules="modules" />
  </v-container>
</template>

<script lang="ts" setup>
import AppDashboard from '@/components/AppDashboard.vue';
import {DashboardModule} from '@/util/dashboard';

const modules: DashboardModule[] = [
  {
    name: 'Alle',
    color: 'dark',
    desc: '',
    icon: 'mdi-account-multiple',
    outlined: true,
    actions: [{name: 'Öffnen', to: {name: 'customer_list'}}],
    hideInNav: false,
    badgeContent: null,
  },
  {
    name: 'Kunden',
    color: 'success',
    desc: '',
    icon: 'mdi-account',
    outlined: true,
    actions: [{name: 'Öffnen', to: {name: 'customer_list', query: {status: 'kunde'}}}],
    hideInNav: false,
    badgeContent: null,
  },
  {
    name: 'Interessenten',
    color: 'warning',
    desc: '',
    icon: 'mdi-account-star',
    outlined: true,
    actions: [{name: 'Öffnen', to: {name: 'customer_list', query: {status: 'interessent'}}}],
    hideInNav: false,
    badgeContent: null,
  },
  {
    name: 'Lieferanten',
    color: 'info',
    desc: '',
    icon: 'mdi-truck-delivery',
    outlined: true,
    actions: [{name: 'Öffnen', to: {name: 'customer_list', query: {status: 'lieferant'}}}],
    hideInNav: false,
    badgeContent: null,
  },
  {
    name: 'Umkreissuche',
    color: 'secondary',
    desc: 'Firmen im Umkreis anzeigen',
    icon: 'mdi-crosshairs-gps',
    actions: [{name: 'Öffnen', to: {name: 'customer_nearby_list'}}],
    hideInNav: false,
    badgeContent: null,
  },
];
defineExpose({
  AppDashboard,
  modules,
});
</script>
